import app from './lib/pico-init'
import { docReady } from './lib/utils'
import $ from 'quantdom'

app.mount()

//web components
import { AccordionItem } from './components/web-components/accordion-item.js'
import { AddButton } from './components/web-components/add-button'
import { BodyOverlay } from './components/web-components/body-overlay'
import { BundleDiscountProgress } from './components/web-components/bundle-discount-progress.js'
import { CartCount } from './components/web-components/cart-count'
import { CartDrawer } from './components/web-components/cart-drawer'
import { CartDrawerInterstitial } from './components/web-components/cart-drawer-interstitial'
import { DropdownButton } from './components/web-components/dropdown-button'
import { FreeShippingProgress } from './components/web-components/free-shipping-progress'
import { ModalItem } from './components/web-components/modal-item.js'
import { OfferDrawer } from './components/web-components/offer-drawer.js'
import { SideDrawer } from './components/web-components/side-drawer'
import { SideDrawerBtn } from './components/web-components/side-drawer-btn'

export { AccordionItem, AddButton, BodyOverlay, DropdownButton, FreeShippingProgress, ModalItem }
docReady(() => {
  const landingPage = sessionStorage.getItem('_landingPage')
  if (window?.gtag && !landingPage) {
    const { origin, pathname, searchParams } = new URL(window.location)
    gtag('event', 'Landing Page', {
      event_detail: `${origin}${pathname}`,
      event_detail2: Object.fromEntries(searchParams),
    })
    sessionStorage.setItem('_landingPage', `${origin}${pathname}`)
  }
  $('body').on('click', (e) => {
    const url = new URL(window.location)
    const clickUrl = e.target.href || e.target.getAttribute('data-url')

    if (window?.gtag) {
      gtag('event', 'generic click', {
        Click_Class: e.target.className,
        Click_Text: e.target.innerText,
        Click_URL: clickUrl ?? '',
        Page_Path: url.pathname,
        Page_URL: url.origin,
      })
    }
  })
})
